"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reset = exports.setField = exports.preloadComplete = exports.apply = exports.set = void 0;

var _reduxActions = require("redux-actions");

var types = _interopRequireWildcard(require("./types"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var set = (0, _reduxActions.createAction)(types.SET, function (filterType, value) {
  return {
    filterType: filterType,
    value: value
  };
});
exports.set = set;
var apply = (0, _reduxActions.createAction)(types.APPLY, function (filterType, value, isViewUpdateRequired) {
  return {
    filterType: filterType,
    value: value,
    isViewUpdateRequired: isViewUpdateRequired
  };
});
exports.apply = apply;
var preloadComplete = (0, _reduxActions.createAction)(types.PRELOAD_COMPLETE, function (filterTypes, onMount, abortController) {
  return {
    filterTypes: filterTypes,
    onMount: onMount,
    abortController: abortController
  };
});
exports.preloadComplete = preloadComplete;
var setField = (0, _reduxActions.createAction)(types.SET_FIELD, function (filterType, fieldName, value) {
  return {
    filterType: filterType,
    fieldName: fieldName,
    value: value
  };
});
exports.setField = setField;
var reset = (0, _reduxActions.createAction)(types.RESET, function (filterType) {
  return {
    filterType: filterType
  };
});
exports.reset = reset;